import React, { Component, Fragment } from "react"
import t from "../../../locale"

import "./Bakery.scss"
import BakeryGallery from "./BakeryGallery"

class Bakery extends Component {
  render() {
    return (
      <section id="bakery">
        {typeof t === "function" ?
          <Fragment>
            <h1 className="bakery-header">{t("bakeryHeader")}</h1>
            <div className="container grid">
              <BakeryGallery />
            </div>
          </Fragment>
          : null}
      </section>
    )
  }
}

export default Bakery